export default function ({ store, redirect }) {
  const account = store.state.auth.active_pt;

  if (helpers.isEmpty(account)) {
    return redirect('/panel');
  }

  if (!helpers.isEmpty(account) && account.type != 'LECTURER') {
    return redirect('/panel');
  }
}
